var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.reservation.show || 1
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", [
                                      _vm._v("Edit Rooms, Rates and Guests"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", [
                                      _vm._v(
                                        "Units (" +
                                          _vm._s(_vm.units.length) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Room Type Editor - note that this does save the basic information, but not the breakdown per date yet nor cancellation policies or taxes/fees"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "All prices are in " +
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                          "'s local currency " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_name
                                          )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    _vm._l(_vm.units, function (unit, index) {
                                      return _c("div", [
                                        _c(
                                          "fieldset",
                                          [
                                            _c("legend", [
                                              _vm._v(
                                                "Unit " + _vm._s(index + 1)
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("h3", [
                                                      _vm._v(
                                                        "Room, Rate and Guests"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Room Type",
                                                        items:
                                                          _vm.roomTypeOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value: unit.roomTypeKey,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit,
                                                            "roomTypeKey",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.roomTypeKey",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "3",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Rate Type",
                                                        items:
                                                          _vm.rateTypeOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value: unit.rateTypeKey,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit,
                                                            "rateTypeKey",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.rateTypeKey",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "1",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Adults",
                                                        items:
                                                          _vm.adultGuestOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.guests.adults,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit.guests,
                                                            "adults",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.guests.adults",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "1",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Older Children",
                                                        items:
                                                          _vm.olderChildrenGuestOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.guests
                                                            .olderChildren,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit.guests,
                                                            "olderChildren",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.guests.olderChildren",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "1",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Young Children",
                                                        items:
                                                          _vm.youngChildrenGuestOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.guests
                                                            .youngChildren,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit.guests,
                                                            "youngChildren",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.guests.youngChildren",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "1",
                                                    },
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "Babies",
                                                        items:
                                                          _vm.babiesGuestOptions,
                                                        disabled:
                                                          unit.shouldDelete,
                                                        autocomplete: "",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.guests.babies,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit.guests,
                                                            "babies",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.guests.babies",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "1",
                                                    },
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        label: "Remove",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.shouldDelete,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit,
                                                            "shouldDelete",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.shouldDelete",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "2",
                                                    },
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v("Quote Total:"),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          unit.quoteTotal
                                                        ) +
                                                        _vm._s(
                                                          _vm.reservation.hotel
                                                            .currency
                                                            .currency_code
                                                        ) +
                                                        "\n                                           "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "2",
                                                    },
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v("Commission:"),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          unit.commission
                                                        ) +
                                                        _vm._s(
                                                          _vm.reservation.hotel
                                                            .currency
                                                            .currency_code
                                                        ) +
                                                        "\n                                           "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "2",
                                                    },
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        disabled:
                                                          unit.shouldDelete,
                                                        label: "Is Alternative",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.isAlternative,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit,
                                                            "isAlternative",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.isAlternative",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      md: "2",
                                                    },
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        disabled:
                                                          unit.shouldDelete,
                                                        label: "Is Indicative",
                                                      },
                                                      model: {
                                                        value:
                                                          unit.isIndicative,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            unit,
                                                            "isIndicative",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "unit.isIndicative",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("h3", [
                                                      _vm._v("Policies"),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("label", [
                                                      _vm._v("Payment Policy"),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            unit.paymentPolicyText,
                                                          expression:
                                                            "unit.paymentPolicyText",
                                                        },
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          unit.shouldDelete,
                                                      },
                                                      domProps: {
                                                        value:
                                                          unit.paymentPolicyText,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            unit,
                                                            "paymentPolicyText",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("h3", [
                                                      _vm._v(
                                                        "Additional Fees and Taxes"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("b", [_vm._v("Note:")]),
                                                    _vm._v(
                                                      " Unit specific taxes and additional fees are not yet supported\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "v-btn",
                                        { on: { click: _vm.addUnit } },
                                        [
                                          _c("v-icon", [_vm._v("add")]),
                                          _vm._v(" Add Room"),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { title: "Cancel without changes" },
                          on: { click: _vm.cancel },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: {
                            title: "Save the changes to the reservation",
                          },
                          on: { click: _vm.saveChanges },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }